import withError from "shared/withError/withError";

const BlankComponent = () => null;

export default withError(BlankComponent);
